import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Fleet from './pages/Fleet';
import Services from './pages/Services';
import Transfers from './pages/Transfers';
import Lausanne from './pages/Lausanne';
import About from './pages/About';
import Booking from './pages/Booking';
import Contact from './pages/Contact';

import { RoutePath } from './types';

const App: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path={RoutePath.HOME} element={<Home />} />
          <Route path={RoutePath.FLEET} element={<Fleet />} />
          <Route path={RoutePath.SERVICES} element={<Services />} />
          <Route path={RoutePath.TRANSFERS} element={<Transfers />} />
          <Route path={RoutePath.LAUSANNE} element={<Lausanne />} />
          <Route path={RoutePath.ABOUT} element={<About />} />
          <Route path={RoutePath.BOOKING} element={<Booking />} />
          <Route path={RoutePath.CONTACT} element={<Contact />} />
         
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;